import script from "./OrderTicketsList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTicketsList.vue?vue&type=script&setup=true&lang=js"

import "./OrderTicketsList.vue?vue&type=style&index=0&id=ba7806f4&lang=scss"

const __exports__ = script;

export default __exports__